/* __next_internal_client_entry_do_not_use__ DismissableTooltip auto */ import { _buildTooltip } from "./common";
export var DismissableTooltip = function(dismissableTooltipProps) {
    return _buildTooltip(dismissableTooltipProps, true);
};
